export const getDecorationTypeMappedList = (typeList) => {

    const updatedThematicsLv2 = typeList.thematicsLv2.map((item) => {
        const thematicLv1 = typeList.thematicsLv1.find(obj => obj.id === item.parentId);
        const updatedTitle = `${thematicLv1.title} - ${item.title}`
        return { ...item, title: updatedTitle }
    });

    const updatedThematicsLv3 = typeList.thematicsLv3.map((item) => {
        var updatedTitle;
        if (item.parentLv1Id) {
            if (item.parentLv2Id) {
                const thematicLv1 = typeList.thematicsLv1.find(t1 => t1.id === item.parentLv1Id)
                const thematicLv2 = typeList.thematicsLv2.find(t2 => t2.id === item.parentLv2Id)
                updatedTitle = `${thematicLv1.title} - ${thematicLv2.title} - ${item.title}`
            } else {
                const thematicLv1 = typeList.thematicsLv1.find(t1 => t1.id === item.parentLv1Id)
                updatedTitle = `${thematicLv1.title} - ${item.title}`
            }
        }
        else {
            updatedTitle = item.title
        }
        return { ...item, title: updatedTitle }
    });

    return {
        ...typeList,
        thematicsLv2: updatedThematicsLv2,
        thematicsLv3: updatedThematicsLv3
    }
}